import React, {useEffect, useState} from 'react';
import {Inplace, InplaceDisplay, InplaceContent} from 'primereact/inplace';
import { Button } from 'primereact/button'
import {extract} from "../utils";
import _ from 'lodash';
import {InputText} from "primereact/inputtext";
type InplaceCustomOptionProps = {
    customLabel?:string
    customBtnLabel?:string
    addCustomOption?: (optionVal:string) => void
    optionValue?: string
}
const InplaceCustomOption  = ({optionValue = '', customLabel, customBtnLabel, addCustomOption}:InplaceCustomOptionProps) => {
    const [customOption, setCustomOption] = useState( '')
    const [inplaceActive, setInplaceActive] = useState(false)
    useEffect( () => {
        setCustomOption(optionValue)
    }, [optionValue])
    const saveCustomOption = (e) => {
        closeCustomOption(e)
        if(customOption && addCustomOption)addCustomOption(customOption)
    }
    const closeCustomOption = (e) => {
        e.preventDefault()
        setInplaceActive(false)
        setCustomOption('')

    }
    const onKeyDown = e => (e.key === 'Enter') ? saveCustomOption(e) : null

    return <>
        <div className="grid p-fluid" style={{marginTop: '10px',width: '100%'}}>
            <div className="col-12">
                <Inplace active={inplaceActive} onToggle={(e) => setInplaceActive(e.value)}>
                    <InplaceDisplay>
                        {customLabel || 'Add New Option'}
                    </InplaceDisplay>
                    <InplaceContent>
                        <div className="p-inputgroup" >
                            <Button icon="pi pi-times" className={' p-button-secondary'} onClick={closeCustomOption}/>
                            <InputText onKeyDown={onKeyDown} autoFocus placeholder={customLabel || "Add New Option..."} value={customOption} onChange={e => setCustomOption(e.target.value)}/>
                            <Button label={customBtnLabel || "ADD"} onClick={saveCustomOption}/>
                        </div>
                    </InplaceContent>
                </Inplace>
            </div>
        </div>
    </>
}

export default InplaceCustomOption